module.exports = __webpack_public_path__ + "img/upc.d2615d44.svg";